/* eslint-disable prettier/prettier */
import DOMPurify from 'dompurify';
import CryptoJS from 'crypto-js';

export const sanitizeString = (value, textos_maliciosos) => {
  if (typeof (value) == 'string') {
    let value2 = value.replace(new RegExp(`\\b${atob(textos_maliciosos)}\\b|--`, 'gi'), '');


    return DOMPurify.sanitize(value2);
  }

  return value;
};

export const detectCodMalicioso = (input, textos_maliciosos) => {
  let value = input;

  if (typeof (input) == 'string' && input != 'undefined' && input != undefined) {

    value = input.replace(new RegExp(`\\b${atob(textos_maliciosos)}\\b|--`, 'gi'), '');

    const sanitized = DOMPurify.sanitize(value);
    // Se o sanitizado é diferente do original, há algo suspeito
    const isMalicious = input !== sanitized;
    return isMalicious;
  }

  return false;
}

export const validaPermissao = (arr, permissao) => {

  let result = arr.some(e => e >= permissao);

  return result;
}

export const retornaHoraEmMilessegundos = (hora = 1) => {

  return (hora * 60 * 60 * 1000)
}

export const retornaArrayMeses = () => {
  return [
    { label: 'Janeiro', value: '1' },
    { label: 'Fevereiro', value: '2' },
    { label: 'Março', value: '3' },
    { label: 'Abril', value: '4' },
    { label: 'Maio', value: '5' },
    { label: 'Junho', value: '6' },
    { label: 'Julho', value: '7' },
    { label: 'Agosto', value: '8' },
    { label: 'Setembro', value: '9' },
    { label: 'Outubro', value: '10' },
    { label: 'Novembro', value: '11' },
    { label: 'Dezembro', value: '12' }
  ];
}


export const encriptJson = (obj, keys) => {

  const jsonStr = JSON.stringify(obj);

  const encrypted = CryptoJS.AES.encrypt(jsonStr, CryptoJS.enc.Utf8.parse(atob(keys.key_encrypt_front)), {
    iv: CryptoJS.enc.Utf8.parse(atob(keys.iv_encrypt_front)),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();
}


export const decryptJson = (encryptedBase64, keys) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, CryptoJS.enc.Utf8.parse(atob(keys.key_decrypt_front)), {
      iv: CryptoJS.enc.Utf8.parse(atob(keys.iv_decrypt_front)),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {

  }
}

export const decryptJsonAuth = (value, keys) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(value, CryptoJS.enc.Utf8.parse(keys.keyEncrypt.slice(0, 32)), {
      iv: CryptoJS.enc.Utf8.parse(keys.ivEncrypt.slice(0, 16)),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {


  }
}

export const jsonBase64 = (jsonData) => {
  return btoa(unescape(encodeURIComponent(jsonData)));
}

export const encodeBase64 = (texto) => {
  return btoa(texto);
}

export const decodeBase64 = (texto) => {
  return atob(texto);
}

export const clickDownloadFile = (binary, fileName) => {
  const url = window.URL.createObjectURL(new Blob([binary]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const formatDateFromBr = (text) => {
  if (text == "" || text == null || text == undefined || text == 'undefined') {
    return "";
  }
  const dataNew = text.split("T");
  const dataArr = dataNew[0].split("-")
  return `${dataArr[2]}/${dataArr[1]}/${dataArr[0]}`;
}